<section class="nf-container">
    <h1 class="title">The page you are looking for is not found!</h1>
    <span class="f-o-f">404</span>
</section>